<template>
  <div class="form-group">
    <label v-if="label" class="form-label">{{ label }}</label>
    <treeselect v-model="selectedItem" :multiple="false" :options="items">
      <template #option-label="{ node, labelClassName }">
        <label :class="labelClassName">
          <span
            v-if="node.children && node.children.length > 0"
            class="fa-solid fa-folder mr-1 folder-icon"
          ></span
          ><span v-else class="fa-solid fa-file mr-1"></span>{{ node.label }}
        </label>
      </template>
    </treeselect>
  </div>
</template>
<script>
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";

export default {
  components: { Treeselect },
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    modelValue: {
      required: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      required: true,
    },
  },
  computed: {
    selectedItem: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/_css/variables.scss";
.vue-treeselect__control,
.vue-treeselect__menu {
  border-radius: $input-border-radius !important;
}

.vue-treeselect__menu {
  margin-top: 5px !important;
}
</style>
<style lang="scss" scoped>
@import "@/_css/variables.scss";

.folder-icon {
  color: $brand-600;
}
</style>